var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 17.615,
  height: 18.78,
  fill: "transparent",
  stroke: "#4264FD",
  strokeWidth: 1.5,
  rx: 1,
  transform: "matrix(.98936 .14551 -.19023 .98174 8.073 4.5)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4264FD",
  strokeWidth: 1.5,
  d: "m6.424 15.218 16.752 1.281m-9.534-10.99-1.568 9.839m6.377.288-2.094 8.715"
})));
export default SvgIconLand;